import React from 'react'
import { auth } from '../../firebase'
import { signOut } from 'firebase/auth'
import logoStadium from '../../images/logo_stadium.png'
import './Header.css'

const Header = () => (
  <div className='header'>
    <div className='header__title'>
      <img src={logoStadium} alt='Stadium' />
    </div>
    <div className='header__version'>
      <span>V1.4.0</span>
    </div>
    <div className='header__links'>
      <a href='#logout' onClick={(ev) => {
        ev.preventDefault()
        signOut(auth)
          .then(() => {
            console.log('Logout')
          })
          .catch((err) => {
            console.error(err)
          })
      }}>Cerrar sesión</a>
    </div>
  </div>
)

export default Header
